(() => {
  const activity = document.querySelector('[data-ccp-activity]');
  if (!activity || activity.dataset.initialized === 'true') return;

  const endpoint = activity.dataset.activityEndpoint?.replace(/\/$/, '');
  const articleKey = activity.dataset.articleKey;
  if (!endpoint || !articleKey) return;

  activity.dataset.initialized = 'true';
  const readCount = activity.querySelector('[data-ccp-read-count]');
  const likeCount = activity.querySelector('[data-ccp-like-count]');
  const likeButton = activity.querySelector('[data-ccp-like]');
  const likedKey = `ccp-blog-liked:${articleKey}`;

  const setCounts = (stats) => {
    if (readCount && Number.isFinite(Number(stats.reads))) readCount.textContent = Number(stats.reads).toLocaleString();
    if (likeCount && Number.isFinite(Number(stats.likes))) likeCount.textContent = Number(stats.likes).toLocaleString();
  };

  const request = async (path, options = {}) => {
    const response = await fetch(`${endpoint}${path}`, {
      ...options,
      headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
    });
    if (!response.ok) throw new Error(`Activity request failed: ${response.status}`);
    return response.json();
  };

  request(`/api/stats?article=${encodeURIComponent(articleKey)}`)
    .then(setCounts)
    .catch(() => {});

  if (likeButton) {
    const alreadyLiked = localStorage.getItem(likedKey) === 'true';
    likeButton.setAttribute('aria-pressed', String(alreadyLiked));
    likeButton.disabled = alreadyLiked;
    likeButton.addEventListener('click', async () => {
      likeButton.disabled = true;
      try {
        const stats = await request('/api/like', { method: 'POST', body: JSON.stringify({ article: articleKey }) });
        localStorage.setItem(likedKey, 'true');
        likeButton.setAttribute('aria-pressed', 'true');
        setCounts(stats);
      } catch (_error) {
        likeButton.disabled = false;
      }
    });
  }

  if (!window.Shopify?.designMode) {
    const dateKey = new Date().toISOString().slice(0, 10);
    const viewedKey = `ccp-blog-viewed:${articleKey}:${dateKey}`;
    if (sessionStorage.getItem(viewedKey) !== 'true') {
      request('/api/view', { method: 'POST', body: JSON.stringify({ article: articleKey }) })
        .then((stats) => {
          sessionStorage.setItem(viewedKey, 'true');
          setCounts(stats);
        })
        .catch(() => {});
    }
  }
})();
